import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

import Text from '@zenbusiness/zui/Text';

import * as Styled from './MarkdownRenderer.style';

import { SmartLink } from '../SmartLink';

/**
 * Maps the markdown components to zui components.
 */
const markdownComponents = {
  h2: ({ children }) => <Styled.MarkdownHeading weight="bold">{children}</Styled.MarkdownHeading>,
  h3: ({ children }) => <Styled.MarkdownHeading weight="medium">{children}</Styled.MarkdownHeading>,
  a: ({ children, href }) => <SmartLink url={href}>{children}</SmartLink>,
  p: ({ children }) => <Styled.MarkdownParagraph>{children}</Styled.MarkdownParagraph>,
  strong: ({ children }) => (
    <Text component="span" weight="bold" size="sm">
      {children}
    </Text>
  ),
  ul: ({ children }) => (
    <ul
      style={{
        marginBottom: '1rem',
        paddingLeft: '1.5rem',
        listStyleType: 'disc',
        listStylePosition: 'outside',
      }}
    >
      {children}
    </ul>
  ),
  ol: ({ children }) => (
    <ol
      style={{
        marginBottom: '1rem',
        paddingLeft: '1.5rem',
        listStyleType: 'decimal',
        listStylePosition: 'outside',
      }}
    >
      {children}
    </ol>
  ),
  li: ({ children }) => (
    <li
      style={{
        marginBottom: '0.5rem',
        display: 'list-item',
        listStyleType: 'inherit',
      }}
    >
      <Text component="span" size="sm">
        {children}
      </Text>
    </li>
  ),
};

/**
 * Renders the markdown content.
 * @param {object} props - The component props.
 * @param {string} props.children - The markdown content.
 * @returns {Element} The rendered markdown content. A list of zui components.
 */
function MarkdownRenderer({ children }) {
  return (
    <div style={{ width: '100%', maxWidth: 'none' }}>
      <ReactMarkdown components={markdownComponents}>{children}</ReactMarkdown>
    </div>
  );
}

MarkdownRenderer.propTypes = {
  children: PropTypes.string.isRequired,
};

export default MarkdownRenderer;
